'use client'

import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import styles from './CenteredPicturePhraseTextSeror.module.scss';

interface CenteredPicturePhraseTextSerorProps {
  imageUrl: string;
  imageHeight?: string;
  imageWidth?: string;
  imageTitle?: string;
  phrase: string;
  details?: string;
  buttonText?: string;
  onButtonClick?: () => void;
}

const CenteredPicturePhraseTextSeror: React.FC<CenteredPicturePhraseTextSerorProps> = ({
  imageUrl,
  imageHeight = '800px',
  imageWidth = '480px',
  imageTitle = 'Artwork',
  phrase,
  details,
  buttonText = 'En savoir plus',
  onButtonClick,
}) => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-in-out',
    });
  }, []);

  return (
    <section className={styles.wrapper}>
      <div
        className={styles.inner}
        style={{ width: imageWidth }}
        data-aos="fade-up"
      >
        <h2
          className={`${styles.phrase} ${styles.typewriter}`}
          data-aos="fade-up"
          data-aos-delay="200"
        >
          {phrase}
        </h2>
        <figure className={styles.imageFrame}>
          <img
            src={imageUrl}
            alt={imageTitle}
            className={styles.image}
            data-aos="fade"
            data-aos-delay="400"
            loading="lazy"
            decoding="async"
          />
          <figcaption className={styles.caption}>{imageTitle}</figcaption>
        </figure>
        {/* <div className={styles.detailsBox} data-aos="fade-up" data-aos-delay="600">
          <p className={styles.detailsText}>{details}</p>
          {onButtonClick && (
            <button className={styles.button} onClick={onButtonClick}>
              {buttonText}
            </button>
          )}
        </div> */}
      </div>
    </section>
  );
};

export default CenteredPicturePhraseTextSeror;
